<header
  class="dashboard-header aic-interior-header d-flex align-items-center justify-content-between position-sticky top-0 px-3 px-md-4 py-2 bg-white border-bottom border-warning border-2 shadow-sm">

  <!-- LEFT: Hamburger (mobile) + Breadcrumb -->
  <div class="d-flex align-items-center gap-3">

    <!-- 🍔 MOBILE SIDEBAR TOGGLE -->
    <button v-if="is_mobile"
      class="btn btn-sm btn-outline-dark aic-header-action rounded-circle d-flex align-items-center justify-content-center"
      @click="$emit('toggle-mobile-sidebar')">
      <i class="bi bi-list"></i>
    </button>

    <!-- Breadcrumb -->
    <div class="breadcrumb d-flex align-items-center flex-wrap mb-0 row-gap-2">

      <template v-if="breadcrumb && breadcrumb.length">
        <span v-for="(crumb, i) in breadcrumb" :key="crumb.id + '-' + i" class="d-flex align-items-center ">
          <a v-if="i < breadcrumb.length - 1" href="#" @click.prevent="$emit('breadcrumb-click', crumb.id)"
            class="aic-header-breadcrumb-link text-decoration-none fw-bold">
            {{ crumb.title }}
          </a>

          <span v-else class="text-dark fw-bold text-xs">
            {{ crumb.title }}
          </span>

          <span v-if="i < breadcrumb.length - 1" class="text-secondary mx-2">/</span>
        </span>
      </template>

      <span v-else class="text-dark fw-bold text-xs">
        Dashboard
      </span>

    </div>
  </div>

  <!-- RIGHT: Actions -->
  <ul class="navbar-nav flex-row align-items-center gap-2">

    <!-- Siyanda Assist -->
    <li class="nav-item">
      <BolideAssistantButton @open-assistant="openAssistant" />
    </li>

    <!-- Logout -->
    <li class="nav-item">
      <a href="#" class="nav-link btn btn-sm btn-outline-dark aic-header-action rounded-circle d-flex align-items-center justify-content-center p-0" @click.prevent="logoutUser">
        <i class="bi bi-box-arrow-right fs-6"></i>
      </a>
    </li>

  </ul>

</header>
